const str = (value) => (value === null || value === undefined ? "" : String(value));

export const SHEET_FILES = Object.freeze({
  template: "test_master_template.xlsx",
  export: "test_master_export.xlsx",
  columns: Object.freeze([
    "Test Name",
    "Investigation Type",
    "Category",
    "Price",
    "Codes",
  ]),
});

export const testNameKey = (name) => str(name).trim().toLowerCase();

export const findDuplicateTest = (name, tests, excludeId) => {
  const key = testNameKey(name);
  if (!key) return null;
  const exclude = str(excludeId);
  return (
    (Array.isArray(tests) ? tests : []).find(
      (test) =>
        test &&
        testNameKey(test.name) === key &&
        (!exclude || str(test._id) !== exclude)
    ) ?? null
  );
};

export const duplicateTestMessage = (match) =>
  `A test named "${str(match?.name)}" already exists.`;

/** The server's own wording for a refused request, else the fallback. */
export const serverErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

/** The import report readers are shared by every server-parsed master sheet. */
export { importFailures, importSkipped, importSummary } from "../common/masterSheetReport";
